/* //////////////////////////////////////////////////////////////////////// */
/* */
/* //////////////////////////////////////////////////////////////////////// */

// REF : https://github.com/ethereum/EIPs/blob/master/EIPS/eip-155.md
module.exports = {
    MAINNET: 1,
    ROPSTEN: 3,
    RINKEBY: 4,
    KOVAN: 42,
}

/* //////////////////////////////////////////////////////////////////////// */
/* */
/* //////////////////////////////////////////////////////////////////////// */
